import React, { useState } from 'react';
import {
  Modal,
  Box,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  FormHelperText,
  Snackbar,
  Alert,
  Switch,
  FormControlLabel
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import ImageAnnotationTool from './ImageAnnotationTool';
import MiddleController from './MiddleController';
import { useDispatch } from 'react-redux';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CircularProgress from '@mui/material/CircularProgress';
// eslint-disable-next-line
import { ADD_CAMERA, SET_CAMERA_IMAGE, CAMERA_ADDED } from 'store/actions';
import { createCamera } from '../../../../../api/FM/videoPageApis';
import axios from 'axios';

const AddCameraButton = () => {
  const [openAddCamera, setOpenAddCamera] = useState(false);
  const [openAnnotate, setOpenAnnotate] = useState(false);
  // const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(true);
  const [deviceName, setDeviceName] = useState('');
  const [cameraAddress, setCameraAddress] = useState('');
  const [framesSkipped, setFramesSkipped] = useState(5);
  const [isActive, setIsActive] = useState(true);
  const [annotationStatus, setAnnotationStatus] = useState(null);
  const [isAnnotateEnabled, setIsAnnotateEnabled] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);
  const isLoading = false;

  console.log('device_name', deviceName);
  console.log('camera_addrs', cameraAddress);
  // eslint-disable-next-line
  const [errors, setErrors] = useState({});
  const [cameraImage, setCameraImage] = useState(null);
  const cameraId = null;
  const serviceId = null;
  // const [cameraId, setCameraId] = useState(null);
  // const [serviceId, setServiceId] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'error'
  });
  // const [pipeline, setPipeline] = useState('');
  console.log('service', serviceId);
  const dispatch = useDispatch();

  const handleOpenAddCamera = () => setOpenAddCamera(true);
  const handleCloseAddCamera = () => setOpenAddCamera(false);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const handleCameraAddressBlur = async () => {
    if (!cameraAddress.trim()) return;

    const abortController = new AbortController();

    try {
      setIsAnnotateEnabled(false);

      const response = await axios.post(
        'https://db.neophyte.live/createCamera/api/captureFrame',
        { rtsp: cameraAddress },
        { signal: abortController.signal }
      );

      if (response?.status === 403) {
        setSnackbar({ open: true, message: response.data, severity: 'error' });
        setIsAnnotateEnabled(false);
        return;
      }

      const base64Image = response.data.image;
      if (!base64Image) throw new Error('Base64 image data not found in response');

      setCameraImage(base64Image);
      dispatch({ type: 'SET_CAMERA_IMAGE', payload: base64Image });
      setAnnotationStatus(true);
      setSnackbar({ open: true, message: 'Camera connected successfully!', severity: 'success' });

      setIsAnnotateEnabled(true);
    } catch (error) {
      console.error('Error fetching camera frame:', error);
      setCameraImage('');
      setAnnotationStatus(false);
      setSnackbar({ open: true, message: error.message || 'Invalid Camera Address', severity: 'error' });

      setIsAnnotateEnabled(false);
    } finally {
      abortController.abort();
    }
  };

  const handleCloseAnnotate = () => {
    // setIsSubmitButtonDisabled(false);
    setOpenAnnotate(false);
  };
  // eslint-disable-next-line
  const validate = () => {
    const newErrors = {};
    if (!deviceName) newErrors.deviceName = 'Device Name is required';
    if (!cameraAddress) newErrors.cameraAddress = 'Camera Address is required';
    if (!framesSkipped) newErrors.framesSkipped = 'Please select the number of frames to skip';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = {
        device_name: deviceName,
        camera_address: cameraAddress,
        process_skip_frame: parseInt(framesSkipped),
        active: isActive
      };
      console.log('Creating camera with data:', data);
      const response = await createCamera(data);
      console.log('Camera created successfully:', response);
      dispatch({ type: CAMERA_ADDED });
      console.log('Dispatched CAMERA_ADDED action');
      handleCloseAddCamera();
      setSnackbar({
        open: true,
        message: 'Camera added successfully',
        severity: 'success'
      });
    } catch (error) {
      console.error('Error creating camera:', error);
      setSnackbar({
        open: true,
        message: error.message || 'Failed to add camera',
        severity: 'error'
      });
    }
  };

  return (
    <>
      <div className="relative flex flex-col items-center group">
        <button
          onClick={handleOpenAddCamera}
          className="flex items-center justify-center bg-[#2D9BBC] focus:ring-blue-400 text-white font-semibold rounded-full w-8 h-8 transition-all duration-300 ease-in-out shadow-md hover:shadow-lg relative"
        >
          <AddIcon className="text-2xl" />
        </button>

        {/* Tooltip - Keeps Showing When Hovering Over It */}
        <span className="absolute left-1/2 -translate-x-1/2 z-50 top-full mt-2 bg-blue-100 text-blue-900 text-sm px-3 py-1 rounded-lg border border-blue-300 shadow-md scale-95 opacity-0 pointer-events-none group-hover:scale-100 group-hover:opacity-100 transition-all duration-300 ease-in-out delay-100">
          Add Camera
        </span>
      </div>

      <Modal open={openAddCamera} onClose={handleCloseAddCamera}>
        <Box
          component="form"
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: '8px'
          }}
          onSubmit={handleSubmit}
        >
          <TextField
            label="Device Name"
            value={deviceName}
            onChange={(e) => setDeviceName(e.target.value)}
            fullWidth
            margin="normal"
            error={!!errors.deviceName}
            helperText={errors.deviceName}
          />
          <TextField
            label="Camera Address"
            value={cameraAddress}
            onChange={(e) => setCameraAddress(e.target.value)}
            onBlur={handleCameraAddressBlur}
            fullWidth
            margin="normal"
            error={annotationStatus === false}
            helperText={annotationStatus === false ? 'Invalid Camera Address' : ''}
            InputProps={{
              endAdornment: (
                <>
                  {isLoading && <CircularProgress size={20} className="text-blue-500" />}
                  {!isLoading && annotationStatus === true && <CheckCircleOutlineIcon className="text-green-500 animate-pulse-once" />}
                  {!isLoading && annotationStatus === false && <ErrorOutlineIcon className="text-red-500 animate-shake" />}
                </>
              )
            }}
          />
          <FormControl fullWidth margin="normal" error={!!errors.framesSkipped}>
            <InputLabel>Frames Skipped</InputLabel>
            <Select value={framesSkipped} onChange={(e) => setFramesSkipped(e.target.value)} label="Frames Skipped">
              {[...Array(10)].map((_, i) => (
                <MenuItem key={i} value={i + 1}>
                  {i + 1}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{errors.framesSkipped}</FormHelperText>
          </FormControl>

          <FormControlLabel
            control={<Switch checked={isActive} onChange={(e) => setIsActive(e.target.checked)} color="primary" />}
            label="Camera Active"
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <button
              onClick={() => setOpenAnnotate(true)}
              type="button"
              disabled={!isAnnotateEnabled}
              className={`border-none cursor-pointer text-center px-6 py-2.5 text-white font-semibold rounded-full flex items-center gap-2 transition-all shadow-md hover:shadow-lg ${
                isAnnotateEnabled ? 'bg-[#2e7d32] hover:bg-[#1b5e20] active:bg-[#388e3c] active:scale-95' : 'bg-gray-400 cursor-not-allowed'
              }`}
            >
              Annotate
            </button>
          </Box>
        </Box>
      </Modal>
      {/* <Modal open={openAnnotate} onClose={handleCloseAnnotate} fullScreen>
        <div className='flex'>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            p: 4,
            overflow: 'auto'
          }}
          className="bg-slate-200"
        >
          <ImageAnnotationTool cameraImage={cameraImage} cameraId={cameraId} handleCloseAnnotate={handleCloseAnnotate} />
          <div className="w-full bg-slate-200 ">
            <MiddleController handleCloseAnnotate={handleCloseAnnotate} cameraId={cameraId} />
          </div>
        </Box>
        </div>
      </Modal> */}

      <Modal open={openAnnotate} onClose={handleCloseAnnotate} fullScreen>
        <div className="flex h-full w-full bg-slate-200 p-4 overflow-auto">
          <div className="w-[100%] pr-2">
            <ImageAnnotationTool cameraImage={cameraImage} cameraId={cameraId} handleCloseAnnotate={handleCloseAnnotate} />
          </div>
          <div className="w-1/4 pr-10">
            <MiddleController
              handleCloseAnnotate={handleCloseAnnotate}
              cameraId={cameraId}
              deviceName={deviceName}
              cameraAddress={cameraAddress}
            />
          </div>
        </div>
      </Modal>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddCameraButton;
